<div class="titled-card-container">
  <div class="flex justify-between items-center mb-4" *transloco="let t">
    <div class="grow"></div>
    <div class="flex gap-3">
      <p-button
        [label]="t('user.management.addUser')"
        styleClass="h-10"
        icon="pi pi-plus"
        data-testid="add-user-button"
        (onClick)="handleEditUser()"
      ></p-button>
    </div>
  </div>
  <p-card data-testid="user-management-card">
    <ng-container *transloco="let t">
      <p-table
        #dt
        [value]="users()"
        [rows]="10"
        [paginator]="true"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{{ 'common.table.currentPageReportTemplate' | transloco }}"
        [globalFilterFields]="globalFilterFields"
        [tableStyle]="{'min-width': '50rem'}"
        [loading]="loading()"
        dataKey="userId"
        selectionMode="multiple"
        data-testid="user-management-table"
      >
        <ng-template #caption>
          <div class="flex justify-end">
            <app-global-search (searchValue)="dt.filterGlobal($event, 'contains')" />
          </div>
        </ng-template>
        <ng-template #header>
          <tr>
            <th pSortableColumn="firstName" data-testid="user-management-name-header" scope="col">
              {{ t('common.firstName') }}
              <p-sortIcon field="firstName"></p-sortIcon>
            </th>
            <th pSortableColumn="lastName" data-testid="user-management-name-header" scope="col">
              {{ t('common.lastName') }}
              <p-sortIcon field="lastName"></p-sortIcon>
            </th>
            <th pSortableColumn="email" data-testid="user-management-email-header" scope="col">
              {{ t('common.email') }}
              <p-sortIcon field="email"></p-sortIcon>
            </th>
            <th
              pSortableColumn="phoneNumber"
              data-testid="user-management-phoneNumber-header"
              scope="col"
            >
              {{ t('common.phoneNumber') }}
              <p-sortIcon field="phoneNumber"></p-sortIcon>
            </th>
            <th pSortableColumn="role" data-testid="user-management-roles-header" scope="col">
              {{ t('common.role') }}
              <p-sortIcon field="role"></p-sortIcon>
            </th>
            <th pSortableColumn="state" data-testid="user-management-roles-header" scope="col">
              {{ t('common.state') }}
              <p-sortIcon field="state"></p-sortIcon>
            </th>
            <th style="width: 5rem" scope="col"></th>
          </tr>
        </ng-template>
        <ng-template #body let-user>
          <tr [attr.data-user-id]="user.userId">
            <td data-testid="user-management-firstname-cell">{{ user.firstName }}</td>
            <td data-testid="user-management-lastname-cell">{{ user.lastName }}</td>
            <td data-testid="user-management-email-cell">{{ user.email }}</td>
            <td data-testid="user-management-phoneNumber-cell">{{ user.phoneNumber }}</td>
            <td data-testid="user-management-roles-cell">{{ this.getRoleName(user.role) }}</td>
            <td data-testid="user-management-state-cell">
              {{ user.state ? t('provider.user.state.' + user.state) : '' }}
              @if (user.scimManaged) {
                <p-tag
                  severity="secondary"
                  class="ml-2"
                  [value]="t('user.scimManaged.badge')"
                  [attr.data-testid]="'scim-managed-user-' + user.id"
                />
              }
            </td>
            <td>
              <div class="flex gap-2 justify-center">
                <p-button
                  icon="pi pi-pencil"
                  [rounded]="true"
                  [text]="true"
                  severity="secondary"
                  (onClick)="handleEditUser(user)"
                  [attr.data-testid]="'edit-user-' + user.id"
                />
                @if (!user.scimManaged) {
                  <p-button
                    icon="pi pi-trash"
                    [rounded]="true"
                    [text]="true"
                    severity="danger"
                    (onClick)="handleDeleteUser(user)"
                    [attr.data-testid]="'delete-user-' + user.id"
                  ></p-button>
                }
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template #emptymessage>
          <tr>
            <td colspan="7">{{ t('common.noUsers') }}</td>
          </tr>
        </ng-template>
      </p-table>
      <p-menu #rowMenu popup="true"></p-menu>
    </ng-container>
  </p-card>
</div>

<app-add-edit-provider-user-dialog
  [(visible)]="editUserDialogVisible"
  [inputObject]="selectedUser() || {}"
  [roles]="availableRoles()"
  (submitOutput)="onSubmit($event)"
  [editMode]="isEditMode()"
  [emailEditingDisabled]="emailEditingDisabled()"
  [scimManaged]="!!selectedUser()?.scimManaged"
></app-add-edit-provider-user-dialog>
